angular.module('app').factory('casinoSettingService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoSetting/");

        return {
            getCasinoSettings: function (requestData) {
                return restAngular.
                one("get").
                customGET(param(requestData))
            },
            saveCasinoSetting: function (requestData) {
                return restAngular.
                    one("save").
                    post("", requestData)
            }
        }
    }
]);
